import React, { useContext, useEffect, useRef, useState } from 'react'

import { WappContext } from 'wapplr-react/dist/common/Wapp'
import { copyObject } from 'wapplr/dist/common/utils'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import clsx from 'clsx'

import MenuContext from 'audreys-ui/dist/common/src/components/Menu/context'
import ModalContext from 'audreys-ui/dist/common/src/components/Modal/context'
import Theme from 'audreys-ui/dist/common/src/components/Theme'
import Container from 'audreys-ui/dist/common/src/components/Container'
import AppBar from 'audreys-ui/dist/common/src/components/AppBar'
import Paper from 'audreys-ui/dist/common/src/components/Paper'
import ButtonContext from 'audreys-ui/dist/common/src/components/Button/context'
import ImageContext from 'audreys-ui/dist/common/src/components/Image/context'

import Logo from 'audreys-ui/dist/common/src/components/Logo'

//import MiniCart from '../../postTypes/order/Cart/MiniCart'

import defaultThemes from './theme/index.scss'
import themeCritical from './theme/critical.scss'

import appBarStyle from './additionalComponents/appBar.scss'
import avatarStyle from './additionalComponents/avatar.scss'
import imageStyle from './additionalComponents/image.scss'
import inputStyle from './additionalComponents/input.scss'
import labelStyle from './additionalComponents/label.scss'
import logoStyle from './additionalComponents/logo.scss'
import menuStyle from './additionalComponents/menu.scss'
import menuItemStyle from './additionalComponents/menuItem.scss'
import modalStyle from './additionalComponents/modal.scss'
import paperContentStyle from './additionalComponents/paperContent.scss'
import svgIconStyle from './additionalComponents/svgIcon.scss'

import defaultStyle from './component.css'

import Snackbar from '../Snackbar'
import AppContext from '../App/context'

import DesktopMenu from './components/DesktopMenu'
import MobileMenu from './components/MobileMenu'
import ThemeControlsDesktop from './components/ThemeControlsDesktop'
import UserMenuDesktop from './components/UserMenuDesktop'
import FeaturedButtons from './components/FeaturedButtons'
import Footer from './components/Footer'

import { ComponentByWidth, getDigbyUiFromCookieFunctions } from './components/ComponentByWidth'

export default function Template(props) {

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)

    const { wapp, req, res } = context

    const utils = getUtils(context)

    const {
        classNames = defaultStyle,
        additionalStyles = {
            appBar: appBarStyle,
            avatar: avatarStyle,
            image: imageStyle,
            input: inputStyle,
            label: labelStyle,
            logo: logoStyle,
            menu: menuStyle,
            menuItem: menuItemStyle,
            modal: modalStyle,
            paperContent: paperContentStyle,
            svgIcon: svgIconStyle
        },
        themes = {
            ...Object.keys(defaultThemes).reduce((o, key) => {
                o[key] = [defaultThemes[key], themeCritical[key]].filter((t) => t).join(' ')
                return o
            }, {})
        },
        children,
        menu = [],
        userMenu = [],
        featuredButtons = [],
        FooterProps = {},
        LogoProps = {},
        handlers = {},
        effect,
        ButtonContextValue = {},
        MenuContextValue = {},
        MenuProps,
        MobileMenuProps,
        UserMenuDesktopProps = {},
        ThemeControlsProps = {},
        BeforeChildren = () => <></>,
        BeforeChildrenProps = {},
        fullPage = true,
        size = 'large',
        disableFooter = false,
        disableAppBar = false
    } = props

    function recMenuType(menu) {
        if (menu?.length) {
            menu.forEach((item) => {
                if (item.items) {
                    if (!item.menuType) {
                        item.menuType = 'list'
                    }
                    recMenuType(item.items)
                }
            })
        }
    }

    recMenuType(menu)

    //wapp.styles.use(themes)
    //wapp.styles.use(classNames)

    const { device } = appContext
    const isMobile = (device.type === 'mobile' || device.type === 'tablet' || device.type === 'wearable')

    const rootContainer = useRef()
    const [, setMountedRootContainer] = useState(false)

    const themeRef = useRef()
    const snackActions = useRef()
    const logoRef = useRef()
    const tipModal = useRef()
    const miniCartDesktop = useRef()
    const miniCartMobile = useRef()

    useEffect(() => {

        if (effect) {
            effect({
                actions: {
                    ...themeRef.current?.actions ? themeRef.current.actions : {},
                    setSnackMessage: async function(...attr) {
                        return snackActions?.actions?.setMessage(...attr)
                    },
                    setLogoAnimation: logoRef?.actions?.setRunAnimation || async function() {return null},
                    setLogoBlackAndWhite: logoRef?.actions?.setBlackAndWhite || async function() {return null},
                    updateMiniCart: async function() {
                        return miniCartDesktop?.actions?.update() || miniCartMobile?.actions?.update()
                    }
                }
            })
        }
        return () => {
            if (effect) {
                effect({
                    actions: {
                        ...themeRef.current?.actions ?
                            Object.keys(themeRef.current?.actions).reduce((o, key) => {
                                o[key] = async () => {
                                }
                                return o
                            }, {})
                            : {},
                        setSnackMessage: async () => {
                        },
                        setLogoAnimation: async () => {
                        },
                        setLogoBlackAndWhite: async () => {
                        }
                    }
                })
            }
        }
    })

    const {
        setDigbyUiToCookie,
        getDigbyUiFromCookie
    } = getDigbyUiFromCookieFunctions({ req, res, wapp })

    const digbyUiDataFromCookie = getDigbyUiFromCookie()

    return (
        <Theme
            className={clsx(
                classNames.template,
                { [classNames.notFullPage]: !fullPage }
            )}
            componentsStyle={themes}
            classNames={themes}
            additionalStyles={additionalStyles}
            effect={({ actions }) => {
                themeRef.current = {
                    actions
                }
            }}
            handlers={{
                changeTheme: (payload, state) => {
                    if (wapp.target === 'web') {
                        console.log('[APP] Change theme:', payload, state)
                        setDigbyUiToCookie()
                    }
                },
                changeMode: (payload, state) => {
                    if (wapp.target === 'web') {
                        console.log('[APP] Change prefer color scheme:', payload, state)
                        setDigbyUiToCookie()
                    }
                },
                changeAutoContrast: (payload, state) => {
                    if (wapp.target === 'web') {
                        console.log('[APP] Change auto contrast:', payload, state)
                        setDigbyUiToCookie()
                    }
                },
                changeWidth: (payload, state) => {
                    if (wapp.target === 'web') {
                        console.log('[APP] Change width:', payload, state)
                        setDigbyUiToCookie()
                    }
                },
                ...handlers
            }}
            themes={{
                theme2: themes.theme2
            }}
            modes={{
                theme2: {
                    light: themes.lightMode,
                    dark: themes.darkMode,
                    auto: themes.autoMode
                }
            }}
            scrollContainer={!fullPage ? rootContainer : undefined}
            device={device}
            useStyle={wapp.styles.use}
            state={{
                setTheme: (value) => {
                    let v = res.wappResponse.store.getState('digbyUi.theme')
                    if (v !== value) {
                        res.wappResponse.store.dispatch(wapp.states.runAction('digbyUi', { name: 'theme', value }))
                    }
                },
                getTheme: () => {
                    let v = res.wappResponse.store.getState('digbyUi.theme')
                    if ((wapp.target === 'node' || (res.wapplrReactEndType === 'pipe' || res.wapplrReactEndType === 'pipeWaitForAll')) && typeof v === 'undefined') {
                        const data = getDigbyUiFromCookie()
                        if (data.theme) {
                            v = data.theme
                        }
                    }
                    return v
                },
                setMode: (value) => {
                    let v = res.wappResponse.store.getState('digbyUi.mode')
                    if (v !== value) {
                        res.wappResponse.store.dispatch(wapp.states.runAction('digbyUi', { name: 'mode', value }))
                    }
                },
                getMode: () => {
                    let v = res.wappResponse.store.getState('digbyUi.mode')
                    if ((wapp.target === 'node' || (res.wapplrReactEndType === 'pipe' || res.wapplrReactEndType === 'pipeWaitForAll')) && typeof v === 'undefined') {
                        const data = getDigbyUiFromCookie()
                        if (data.mode) {
                            v = data.mode
                        }
                    }
                    return v
                },
                setAutoContrast: (value) => {
                    let v = res.wappResponse.store.getState('digbyUi.autoContrast')
                    if (v !== value) {
                        res.wappResponse.store.dispatch(wapp.states.runAction('digbyUi', {
                            name: 'autoContrast',
                            value
                        }))
                    }
                },
                getAutoContrast: () => {
                    let v = res.wappResponse.store.getState('digbyUi.autoContrast')
                    if ((wapp.target === 'node' || (res.wapplrReactEndType === 'pipe' || res.wapplrReactEndType === 'pipeWaitForAll')) && typeof v === 'undefined') {
                        const data = getDigbyUiFromCookie()
                        if (typeof data.autoContrast === 'boolean') {
                            v = data.autoContrast
                        }
                    }
                    return v
                },
                setWidth: (value) => {
                    let v = res.wappResponse.store.getState('digbyUi.width')
                    if (v !== value) {
                        res.wappResponse.store.dispatch(wapp.states.runAction('digbyUi', { name: 'width', value }))
                    }
                },
                getWidth: () => {
                    let v = res.wappResponse.store.getState('digbyUi.width')
                    if ((wapp.target === 'node' || (res.wapplrReactEndType === 'pipe' || res.wapplrReactEndType === 'pipeWaitForAll')) && typeof v === 'undefined') {
                        const data = getDigbyUiFromCookie()
                        if (data.width) {
                            v = data.width
                        }
                    }
                    return v
                },
                getState: () => {
                    let v = res.wappResponse.store.getState('digbyUi')
                    if ((wapp.target === 'node' || (res.wapplrReactEndType === 'pipe' || res.wapplrReactEndType === 'pipeWaitForAll')) && !v?.theme) {
                        const data = getDigbyUiFromCookie()
                        if (data.theme) {
                            v = data
                        }
                    }
                    return v
                },
                createStates: (actionType) => {
                    if (!wapp.states.stateManager.actions.digbyUi) {
                        wapp.states.stateManager.actions.digbyUi = function({ type, name, value }) {
                            return {
                                type: type || actionType,
                                payload: {
                                    name,
                                    value
                                }
                            }
                        }
                    }
                    if (!wapp.states.stateManager.reducers.digbyUi) {
                        wapp.states.stateManager.reducers.digbyUi = function(state = {}, action) {
                            switch (action.type) {
                                case actionType:
                                    return {
                                        ...state,
                                        [action.payload.name]: (action.payload.value && typeof action.payload.value == 'object') ? copyObject(action.payload.value) : action.payload.value
                                    }
                                default:
                                    return state
                            }
                        }
                    }
                    if ((wapp.target === 'node' || (res.wapplrReactEndType === 'pipe' || res.wapplrReactEndType === 'pipeWaitForAll'))) {
                        const data = getDigbyUiFromCookie()
                        if (data.theme) {
                            if (res.wappResponse.store.getState('digbyUi.theme') !== data.theme) {
                                res.wappResponse.store.dispatch(wapp.states.runAction('digbyUi', {
                                    name: 'theme',
                                    value: data.theme
                                }))
                            }
                            if (res.wappResponse.store.getState('digbyUi.mode') !== data.mode) {
                                res.wappResponse.store.dispatch(wapp.states.runAction('digbyUi', {
                                    name: 'mode',
                                    value: data.mode
                                }))
                            }
                            if (res.wappResponse.store.getState('digbyUi.autoContrast') !== data.autoContrast) {
                                res.wappResponse.store.dispatch(wapp.states.runAction('digbyUi', {
                                    name: 'autoContrast',
                                    value: data.autoContrast
                                }))
                            }
                            if (res.wappResponse.store.getState('digbyUi.width') !== data.width) {
                                res.wappResponse.store.dispatch(wapp.states.runAction('digbyUi', {
                                    name: 'width',
                                    value: data.width
                                }))
                            }
                        }
                    }
                },
                getAction: () => {
                    return wapp.states.stateManager.actions.digbyUi
                },
                getReducer: () => {
                    return wapp.states.stateManager.reducers.digbyUi
                },
                subscribe: (...attr) => {
                    return res.wappResponse.store.subscribe(...attr)
                }
            }}
        >
            <ImageContext.Provider value={{
                getSrc: ({ src }) => {
                    if (src && src.startsWith('/thumb')) {
                        return `${src.replace('/thumb', '/thumb/2')}`
                    }
                    return src
                }
            }}>
                <ModalContext.Provider value={{ position: !fullPage ? 'absolute' : 'fixed' }}>
                    <MenuContext.Provider value={MenuContextValue}>
                        <ButtonContext.Provider value={{
                            tipOnOpen: async ({ modal }) => {
                                if (modal.actions !== tipModal.actions && tipModal.actions?.setOpen) {
                                    tipModal.actions.setOpen(false)
                                    tipModal.actions = null
                                }
                                const { actions } = modal
                                tipModal.actions = actions
                            },
                            ...ButtonContextValue
                        }}>
                            <Container
                                className={classNames.root}
                                containerVariant={'root'}
                                ref={async (e) => {
                                    rootContainer.current = e
                                    if (!fullPage) {
                                        await setMountedRootContainer(true)
                                    }
                                }}
                            >
                                {!disableAppBar ?
                                <AppBar
                                    className={classNames.appBar}
                                    container-type={'root-root'}
                                    stickyClassName={classNames.appBarSticky}
                                >
                                    <div className={classNames.appBarContainer}>
                                        <div className={classNames.appBarLogo}>
                                            <Logo
                                                ComponentProps={{
                                                    href: '/',
                                                    label: appContext.labels.logoAreaLabel
                                                }}
                                                long={true}
                                                {...LogoProps}
                                                effect={({ actions }) => {
                                                    logoRef.actions = actions
                                                    if (LogoProps.effect) {
                                                        LogoProps.effect({ actions })
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className={classNames.appBarMenu}>
                                            <ComponentByWidth
                                                ComponentDepWidth={{
                                                    narrow: () => <MobileMenu
                                                        MenuProps={MenuProps}
                                                        menu={copyObject(menu, { keep: 'desktopMegaMenuStaticContent' })}
                                                        userMenu={userMenu}
                                                        classNames={classNames}
                                                        featuredButtons={featuredButtons}
                                                        FooterProps={{
                                                            ...LogoProps ? { LogoProps } : {},
                                                            ...FooterProps ? FooterProps : {}
                                                        }}
                                                        LogoProps={LogoProps}
                                                        ThemeControlsProps={{
                                                            ...ThemeControlsProps,
                                                            themeRef
                                                        }}
                                                        size={size}
                                                        MobileMenuProps={MobileMenuProps}
                                                        miniCartRef={miniCartMobile}
                                                    />,
                                                    wide: () => <DesktopMenu
                                                        MenuProps={MenuProps}
                                                        menu={copyObject(menu, { keep: 'desktopMegaMenuStaticContent' })}
                                                        classNames={classNames}
                                                        size={size}
                                                    />
                                                }}
                                                {...(!isMobile) ? { InitialComponent: () => null } : null}
                                                Component={() => null}
                                                {...(digbyUiDataFromCookie?.width) ? {
                                                    isMounted: true,
                                                    width: digbyUiDataFromCookie.width
                                                } : {}}
                                            />
                                        </div>
                                        <ComponentByWidth
                                            ComponentDepWidth={{
                                                narrow: () => null,
                                                wide: () => <>
                                                    <ThemeControlsDesktop
                                                        size={size}
                                                        {...ThemeControlsProps}
                                                        classNames={classNames}
                                                        themeRef={themeRef}
                                                    />
                                                    {featuredButtons?.length ?
                                                        <FeaturedButtons
                                                            featuredButtons={featuredButtons}
                                                            classNames={classNames}
                                                            size={size}
                                                        /> : null
                                                    }
                                                    <UserMenuDesktop
                                                        key={Date.now()}
                                                        classNames={classNames}
                                                        size={size}
                                                        menu={userMenu}
                                                        miniCartRef={miniCartDesktop}
                                                        {...UserMenuDesktopProps}
                                                    />
                                                </>
                                            }}
                                            {...(!isMobile) ? { InitialComponent: () => null } : null}
                                            Component={() => null}
                                            {...(digbyUiDataFromCookie?.width) ? {
                                                isMounted: true,
                                                width: digbyUiDataFromCookie.width
                                            } : {}}
                                        />
                                    </div>
                                </AppBar> : null}
                                <BeforeChildren {...BeforeChildrenProps} />
                                <Container
                                    Component={Paper}
                                    className={classNames.page}
                                    elevation={0}
                                    style={{ borderRadius: 0 }}
                                    container-type={'root-root'}
                                >
                                    {children}
                                </Container>
                                {!disableFooter ?
                                    <Footer
                                        PaperProps={{
                                            'container-type': 'root-root'
                                        }}
                                        classNames={classNames}
                                        key={utils.getRequestUrl()}
                                        {...{
                                            ...LogoProps ? { LogoProps } : {},
                                            ...FooterProps ? FooterProps : {}
                                        }}
                                        size={size}
                                    /> : null
                                }
                            </Container>
                            <Snackbar
                                effect={({ actions }) => {
                                    snackActions.actions = actions
                                }}
                                autoHideDuration={4000}
                            />
                        </ButtonContext.Provider>
                    </MenuContext.Provider>
                </ModalContext.Provider>
            </ImageContext.Provider>
        </Theme>
    )
}
